import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import { useDmControlRoute } from '../actions/dm/control/useDmControlRoute';

// Sized like the scan header's Details toggle; the host must render DmControlRoute.
export function ManageMonitoringButton({ patientId }: { patientId: string }) {
    const { open } = useDmControlRoute(patientId);
    return (
        <button
            type="button"
            onClick={open}
            title="Manage monitoring"
            className="inline-flex shrink-0 items-center gap-1 rounded-md border border-gray-200 bg-white px-2 py-0.5 text-[11px] font-semibold text-gray-500 transition-colors duration-200 hover:text-gray-700"
        >
            <AdjustmentsHorizontalIcon className="h-3.5 w-3.5" />
            Manage monitoring
        </button>
    );
}
